<script>
  import Chartline from "../graph/ChartDefaultMD.svelte";
  import Chartparam from "../graph/ChartDefaultMD2.svelte";
  import ToolsSpinner from "../ihm/ToolsSpinner.svelte";

  import { onMount } from "svelte";
  import { urlServeur } from "../conf";

  let promise;
  let axeHerm;
  let serieHerm;
  let axeFleurs;
  let serieFleurs;
  let axeFleursMois;
  let serieFleursMois;
  let myOption = {
    responsive: true,
    title: {
      display: true,
      position: "top",
      text: "Pie Chart",
      fontSize: 18,
      fontColor: "#111",
    },
  };
  let dataset;

  /**
   *
   */
  const fecthData = async () => {
    const response = await fetch(urlServeur + "/api/immeubles/graphedf");
    const result = await response.json();

    //console.log(result.payload.axe);

    axeHerm = result.payload.axeHerm;
    axeHerm = axeHerm.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
    serieHerm = JSON.parse(result.payload.serieHerm);

    axeFleurs = result.payload.axeFleurs;
    if (axeFleurs !== "[]") {
      axeFleurs = axeFleurs.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
      serieFleurs = JSON.parse(result.payload.serieFleurs);
    }

    axeFleursMois = result.payload.axeFleursMois;
    if (axeFleursMois !== "[]") {
      axeFleursMois = axeFleursMois.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
      serieFleursMois = JSON.parse(result.payload.serieFleursMois);
    }

    dataset = [
      // Objet data passes au chart.
      {
        label: "Edf/Herm",
        backgroundColor: ["rgba(255, 99, 132)"],
        borderColor: ["rgba(255, 99, 132, 1)"],
        data: serieHerm,
      },
    ];
  };

  /**
   *
   */
  onMount(async () => {
    promise = fecthData();
  });

  function renderChart() {}
</script>

<div class="container-fluid">
  <h4>Chart line / EDF</h4>

  <div class="chart-container">
    {#await promise}
      <ToolsSpinner />
    {:then name}
      <h3>Herm</h3>
      <Chartparam
        chartType={"line"}
        chartDatasets={dataset}
        chartDataLabels={axeHerm}
      />

      <h3>Les Fleurs</h3>
      <Chartline
        chartType={"line"}
        chartDatasets={serieFleurs}
        chartDataLabels={axeFleurs}
        chartLabelLine={"Edf/fleurs"}
      />

      <h3>Les Fleurs / Mois</h3>
      <Chartline
        chartType={"line"}
        chartDatasets={serieFleursMois}
        chartDataLabels={axeFleursMois}
        chartLabelLine={"EDF/mois"}
      />
    {/await}
  </div>
</div>

<style>
  .chart-container {
    width: 90%;
    height: 480px;
    margin: 0 auto;
  }
</style>
